module.exports = __webpack_public_path__ + "data-table.bce071e976865da51100.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/@swimlane/ngx-datatable/assets/fonts/data-table.eot
// module id = ../../../../@swimlane/ngx-datatable/assets/fonts/data-table.eot
// module chunks = styles